:host {
  display: flex;
  flex-direction: column;
  width: fit-content;
}

:host .additional-field-wrapper-static::slotted([slot="additional-field"]) {
  margin-top: calc(var(--ic-space-sm) / 2);
  margin-left: var(--ic-space-xl);
}

/* The label turns grey when disabled  */
:host(.ic-radio-option-disabled),
:host(.ic-radio-option-disabled) .radio-label {
  --ic-typography-color: var(--ic-radio-button-text-option-disabled);
}

/* Focus states */
:host .radio-option-container input:focus + span.checkmark,
:host .radio-option-container:hover input:focus + span.checkmark,
:host .radio-option-container:active input:focus + span.checkmark,
:host(:focus) .radio-option-container input:checked + span.checkmark {
  box-shadow: var(--ic-border-focus);
}

/* The container */
:host .radio-option-container {
  display: grid;
  grid-template-columns: min-content auto;
  position: relative;
  cursor: pointer;
  align-items: center;
  margin: var(--ic-space-xxs) 0 var(--ic-space-xxs) var(--ic-space-xxs);
}

:host(.ic-radio-option-small) .radio-option-container {
  margin: 0 0 0 var(--ic-space-xxs);
}

:host .radio-option-container.disabled,
:host .radio-option-container.disabled input:disabled {
  cursor: default;
}

/* Hide the browser's default radio button */
:host .radio-option-container input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  position: absolute;
  cursor: pointer;
  height: var(--ic-space-lg);
  width: var(--ic-space-lg);
  border-radius: 50%;
  border: none;
}

:host(.ic-radio-option-small) .radio-option-container input {
  height: var(--ic-space-md);
  width: var(--ic-space-md);
}

:host(.ic-radio-option-large) .radio-option-container input {
  height: var(--ic-space-xl);
  width: var(--ic-space-xl);
}

/* Create a custom radio button */
:host .checkmark {
  display: block;
  position: relative;
  top: 0;
  left: 0;
  height: var(--ic-space-lg);
  width: var(--ic-space-lg);
  background-color: var(--ic-radio-button-background-default);
  border: var(--ic-space-1px) solid var(--ic-radio-button-border-default);
  border-radius: 50%;
  transition: var(--ic-easing-transition-fast);
  box-sizing: border-box;
}

:host(.ic-radio-option-small) .checkmark {
  height: var(--ic-space-md);
  width: var(--ic-space-md);
}

:host(.ic-radio-option-large) .checkmark {
  height: var(--ic-space-xl);
  width: var(--ic-space-xl);
}

/* Show the indicator (dot/circle) when checked */
:host .radio-option-container input:checked ~ .checkmark::after {
  display: inline-block;
}

/* On mouse-over, add a light blue background color */
:host .radio-option-container:hover input ~ .checkmark {
  box-shadow: 0 0 0 0.25rem var(--ic-radio-button-active-hover);
  border: var(--ic-border-width) solid var(--ic-radio-button-default-hover);
}

:host .radio-option-container:hover input:checked ~ .checkmark {
  box-shadow: 0 0 0 0.25rem var(--ic-radio-button-active-hover);
  border: 0.125rem solid var(--ic-radio-button-default-hover);
}

:host
  .radio-option-container:hover:not(.disabled)
  input:checked
  ~ .checkmark::after {
  background-color: var(--ic-radio-button-default-hover);
}

/* When pressed, adds the active colours */
:host .radio-option-container:active input ~ .checkmark {
  box-shadow: 0 0 0 0.25rem var(--ic-radio-button-active-pressed);
  border: var(--ic-border-width) solid var(--ic-radio-button-default-pressed);
}

/* When pressed, adds the active colours */
:host .radio-option-container:active input:checked ~ .checkmark {
  border: 0.125rem solid var(--ic-radio-button-default-pressed);
  box-shadow: 0 0 0 0.25rem var(--ic-radio-button-active-pressed);
}

:host(.ic-radio-option-small)
  .radio-option-container
  input:checked
  ~ .checkmark {
  border-width: var(--ic-space-1px);
}

/* When pressed and selected, adds the active colours */
:host .radio-option-container:active input:checked ~ .checkmark::after {
  background-color: var(--ic-radio-button-default-pressed);
}

/* When the radio button is checked */
:host .radio-option-container input:checked ~ .checkmark {
  border: 0.125rem solid var(--ic-radio-button-default-active);
}

/* When the radio button is checked and disabled */
:host .radio-option-container input:checked:disabled ~ .checkmark {
  border: 0.125rem solid var(--ic-radio-button-border-disabled);
}

/* When the radio button is disabled */
:host .radio-option-container input:disabled ~ .checkmark {
  border: var(--ic-border-width) dashed var(--ic-radio-button-border-disabled);
}

/* When the radio button is disabled */
:host .radio-option-container input:disabled ~ .checkmark::after {
  background: var(--ic-radio-button-disabled);
}

/* On mouse-over inactive */
:host .radio-option-container:hover input:disabled ~ .checkmark {
  box-shadow: none;
  border: 0.125rem solid none;
}

:host .radio-option-container:active input:disabled ~ .checkmark::after {
  background-color: var(--ic-radio-button-disabled);
}

/* Style the indicator (dot/circle) */
:host .radio-option-container .checkmark::after {
  content: "";
  position: absolute;
  display: none;
  top: calc(50% - var(--ic-space-xs));
  left: calc(50% - var(--ic-space-xs));
  width: var(--ic-space-md);
  height: var(--ic-space-md);
  border-radius: 50%;
  background: var(--ic-radio-button-default-active);
}

:host(.ic-radio-option-small) .radio-option-container .checkmark::after {
  top: 50%;
  left: 50%;
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  background: var(--ic-radio-button-default-active);
  transform: translate(-50%, -50%);
}

:host(.ic-radio-option-large) .radio-option-container .checkmark::after {
  top: 50%;
  left: 50%;
  width: calc(var(--ic-space-md) + var(--ic-space-xxs));
  height: calc(var(--ic-space-md) + var(--ic-space-xxs));
  border-radius: 50%;
  background: var(--ic-radio-button-default-active);
  transform: translate(-50%, -50%);
}

:host .radio-label {
  margin-left: var(--ic-space-md);

  --ic-typography-color: var(--ic-radio-button-text-option);
}

:host(.ic-radio-option-small) .radio-label {
  margin-left: var(--ic-space-xs);
}

:host(.ic-radio-option-large) .radio-label {
  margin-left: var(--ic-space-md);
}

:host .additional-field-wrapper-static {
  margin-left: var(--ic-space-xs);
}

/* The line */
:host .branch-corner {
  color: var(--ic-radio-button-required-bar);
  height: var(--ic-space-md);
  width: var(--ic-space-xl);
  border-radius: 0 0 0 0.188rem;
  border-bottom: 0.125rem solid var(--ic-radio-button-required-bar);
  border-left: 0.125rem solid var(--ic-radio-button-required-bar);
  margin-left: calc(-1 * var(--ic-space-1px));
}

/* The dynamic container */
:host .dynamic-container {
  display: flex;
  position: relative;
  margin: var(--ic-space-xxs) 0 var(--ic-space-xxs) var(--ic-space-md);
  gap: var(--ic-space-xs);
}

:host(.ic-radio-option-small) .dynamic-container {
  margin-left: var(--ic-space-sm);
}

:host(.ic-radio-option-large) .dynamic-container {
  margin-left: calc(var(--ic-space-md) + var(--ic-space-xxs));
}

:host .dynamic-container.hidden {
  display: none;
}

:host .dynamic-text {
  color: var(--ic-radio-button-required-text);

  --ic-typography-color: var(--ic-radio-button-required-text);

  margin-top: calc(var(--ic-space-sm) / 2);
  margin-bottom: var(--ic-space-xs);
  border-radius: 2%;
}

@media (max-width: 576px) {
  :host .additional-field-wrapper-dynamic::slotted(ic-text-field),
  :host .additional-field-wrapper-static::slotted(ic-text-field) {
    --input-width: 100%;
  }
}

@media (forced-colors: active) {
  /* Styles here only apply to Forced Colors Mode */

  :host .radio-option-container input:checked ~ .checkmark,
  :host .radio-option-container:active input:checked ~ .checkmark {
    border-color: Highlight;
  }

  :host .radio-option-container input:checked ~ .checkmark::after,
  :host .radio-option-container:active input:checked ~ .checkmark::after {
    background-color: Highlight;
  }

  :host .radio-option-container input:disabled ~ .checkmark,
  :host .radio-option-container input:checked:disabled ~ .checkmark {
    border-color: GrayText;
  }

  :host .radio-option-container input:disabled ~ .checkmark::after,
  :host .radio-option-container:active input:disabled ~ .checkmark::after {
    background-color: GrayText;
  }
}

/* Right to left */
:host input[type="radio"]:dir(rtl) {
  right: 0;
}

:host .radio-label:dir(rtl) {
  padding-right: var(--ic-space-sm);
  padding-left: 0;
}

:host .branch-corner:dir(rtl) {
  border-radius: 0 0 0.188rem;
  border-right: 0.125rem solid var(--ic-action-default);
  border-left: none;
}

:host .dynamic-container:dir(rtl) {
  margin: var(--ic-space-xxxs) var(--ic-space-sm) var(--ic-space-xxs) 0;
}

@media (prefers-reduced-motion: reduce) {
  :host .checkmark {
    transition: none;
  }
}
